import React, { useState } from 'react';

import Input from './input';

import type { CustomField } from 'bundles/apex/custom_fields/types';
import type { Value } from './types';

interface Props {
  bracketizeName?: boolean;
  customField: CustomField,
  inputNamePrefix?: string;
  value: Value;
}

export default function ApexCustomFieldRawInput({
  bracketizeName = false,
  customField,
  inputNamePrefix = '',
  value: initialValue = null,
}: Props) {
  const [value, setValue] = useState<Value>(initialValue);

  let { name } = customField;
  if (bracketizeName) {
    name = `[${name}]`;
  }

  let hiddenValue: string;
  if (customField.type === 'boolean') {
    if (value === true) {
      hiddenValue = 'true';
    } else if (value === false) {
      hiddenValue = 'false';
    } else {
      hiddenValue = '';
    }
  } else {
    hiddenValue = value == null ? '' : String(value);
  }

  return <>
    <Input
      customField={customField}
      value={value}
      onValueChange={setValue}
    />

    <input
      name={`${inputNamePrefix}${name}`}
      type="hidden"
      value={hiddenValue}
    />
  </>;
}
